export default {"src":"/_next/static/media/home-solid.0f0fc2ff.svg","height":16,"width":18};